/**
 * Serviço para consultar informações sobre salas do Daily.co
 */

// API Key do Daily.co
const DAILY_API_KEY = 'd8f65d2ea11d61f246be3e46facbacb4805bf9f6f74239b05019a0912df0916c';
const DAILY_DOMAIN = 'multiverso.daily.co';

class DailyRoomService {
  // Mapa para armazenar a última contagem de participantes por sala
  static lastParticipantCount: Map<string, number> = new Map();
  /**
   * Obtém informações sobre os participantes de uma sala específica
   * @param roomName Nome da sala (sem o domínio)
   * @returns Promessa que resolve para o número de participantes na sala
   */
  public static async getRoomParticipantCount(roomName: string): Promise<number> {
    try {
      // Formatar o nome da sala (substituir vírgulas por hífens para evitar erros 404)
      const formattedRoomName = roomName.replace(/,/g, '-');

      // URL da API do Daily.co para obter informações sobre a sala
      // Adicionar timestamp para evitar cache
      const timestamp = Date.now();
      const url = `https://api.daily.co/v1/rooms/${formattedRoomName}/presence?_t=${timestamp}`;

      // Fazer a requisição para a API do Daily.co
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${DAILY_API_KEY}`
        }
      });

      // Verificar se a requisição foi bem-sucedida
      if (!response.ok) {
        console.error(`[DailyRoomService] Erro ao obter informações da sala ${roomName}: ${response.status} ${response.statusText}`);
        return 0;
      }

      // Converter a resposta para JSON
      const data = await response.json();

      // Verificar se a resposta contém a lista de participantes
      if (data && data.data && Array.isArray(data.data)) {
        // Retornar o número de participantes na sala
        const count = data.data.length;
        // Reduzir logs repetitivos - apenas logar em desenvolvimento ou quando houver mudança
        if (process.env.NODE_ENV === 'development' || count !== DailyRoomService.lastParticipantCount.get(roomName)) {
          console.log(`[DailyRoomService] Sala ${roomName} tem ${count} participantes`);
          // Armazenar a contagem atual para comparação futura
          DailyRoomService.lastParticipantCount.set(roomName, count);
        }
        return count;
      }

      return 0;
    } catch (error) {
      console.error(`[DailyRoomService] Erro ao obter informações da sala ${roomName}:`, error);
      return 0;
    }
  }
}

export default DailyRoomService;
